import React, { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom"

import APICtx from '#api'
import { TplWSidebar as Tpl } from '#Template'
import Form, { Input, InputNumber, Select, Autocomplete } from '#Form'
import { offerTypes } from './schemas'
import { Paper } from '@mui/material';

export default function OffersEdit() {
	const api = useContext(APICtx)
	const { _id } = useParams()
	const [ traderId, setTraderId ] = useState(null)
	const [ traderInfo, setTraderInfo ] = useState([])
	const [ tradersOptions, setTraderOptions ] = useState([])
	const [ categoriesOpts, setCategoriesOpts ] = useState([])
	const [ productsOpts, setProductsOpts ] = useState([])
	const [ workingHeight, setWorkingHeight ] = useState(0)
	const [ type, setType ] = useState(null)
	const [ category, setCategory ] = useState(null)
	const [ product, setProduct ] = useState(null)
	const [ productData, setProductData ] = useState({})
	const [ transportPrices, setTransportPrices ] = useState([])
	const [ email1, setEmail1 ] = useState(null)
	const [ email2, setEmail2 ] = useState(null)
	const [ email3, setEmail3 ] = useState(null)
	const [ email4, setEmail4 ] = useState(null)
	const [ email5, setEmail5 ] = useState(null)
	const [ priceFull, setPriceFull ] = useState(null)
	const [ priceDiscount, setPriceDiscount ] = useState(null)
	const [ promotion, setPromotion ] = useState({})
	const [ data, setData ] = useState({})

	const autocompleteEmail = async (hint) => {
		const emails = await api.call('offers/listEmails', { hint })
		if(!emails.includes(hint))
			emails.unshift(hint)
		return emails.map(email =>
			({ value:email, label:email })
		)
	}

	useEffect(() => {
		product ? api.call('platforms/get', { _id:product }).then(setProductData) : setProductData({})
	}, [ product ])
	useEffect(() => {
		productData?.notes && setData({ ...data, notes:productData.notes })
	}, [ productData ])
	useEffect(() => {
		let priceFull = undefined
		if(type === 'rent-daily' && productData?.priceRentDaily)
			priceFull = productData.priceRentDaily
		if(type === 'rent-monthly' && productData?.priceRentMonthly)
			priceFull = productData.priceRentMonthly

		if(priceFull) {
			setData({ ...data, priceFull })
			setPriceFull(priceFull)
		}
	}, [ productData, type ])

	useEffect(() => {
		traderId ? api.call('agents/get', { uid:traderId }).then(setTraderInfo) : setTraderInfo({})
	}, [ traderId ])
	useEffect(() => {
		const traderDiscount = traderInfo?.shipDiscount || 0
		data.shipDiscount !== traderDiscount && setData({ ...data, shipDiscount:traderDiscount })
	}, [ data, traderInfo ])

	useEffect(() => {
		api.call('products-categories/options', { type:'platform', workingHeight }).then(setCategoriesOpts)
	}, [ workingHeight ])
	useEffect(() => {
		category ? api.call('platforms/options', { category, workingHeight }).then(setProductsOpts) : setProductsOpts([])
	}, [ workingHeight, category ])
	useEffect(() => {
		const priceTmp = Math.round(priceFull * (1 - (priceDiscount / (100 * 10000))))
		const price = priceTmp > 0 ? priceTmp : 0
		setData({ ...data, price })
	}, [ priceFull, priceDiscount ])
	useEffect(() => {
		if(api.auth.chk('offers-dataentry'))
			api.auth.usersAsOptions({ acl:'offers-trader' }).then(setTraderOptions)
		else {
			setTraderOptions({})
		}
		api.call('transport-prices/options', { mode:'socar' }).then(setTransportPrices)
	}, [])

	// promotion
	useEffect(() => {
		const isChanged = promotion?.type !== type || promotion?.category !== category || promotion?.traderId !== traderId
		isChanged && api.call('promotions/match-offer', { type, productCategory:category, trader:traderId })
			.then(promotion => {
				setPromotion({ ...promotion, type, category, traderId })
				if(promotion?.label) {
					setData({
						...data,
						priceDiscount: promotion.discount,
						promotionLabel: promotion.label,
					})
					setPriceDiscount(promotion.discount)
				}
				else
					setData({
						...data,
						promotionLabel: '',
					})
			})
	}, [ type, category, traderId ])

	const title = (_id ? 'Modifica' : 'Crea') + ' offerta'
	const formDef = {
		_id,
		callSet: "offers/set",
		callGet: _id && "offers/get",
		data, setData,
		onLoad: data => {
			setType(data.type)
			setCategory(data.productCategory)
			setProduct(data.product)
			setEmail1(data.emailRecipient1)
			setEmail2(data.emailRecipient2)
			setEmail3(data.emailRecipient3)
			setEmail4(data.emailRecipient4)
			setEmail5(data.emailRecipient5)
			setPriceFull(data.priceFull)
			setPriceDiscount(data.priceDiscount)
			setTraderId(data.trader || api.auth.uid)
		},
	}

	const emailsCount = [
		email1,
		email2,
		email3,
		email4,
		email5,
	].filter(Boolean).length
	return (
		<Tpl title={title} backTo="/platforms/offers">
			<Form {...formDef}>
				<Paper sx={{ p:1, mb:1 }}>
					{ api.auth.chk('offers-dataentry') && (
						<Select label="Commerciale" name="trader" options={tradersOptions} onChange={setTraderId} required emptyLabel="-- Seleziona un commerciale --" />
					)}
					<Autocomplete label="Email" name="emailRecipient1" getOptions={autocompleteEmail} required onChange={setEmail1} />
					{ Boolean(emailsCount>0 || email2) && <Autocomplete label="Email" name="emailRecipient2" getOptions={autocompleteEmail} onChange={setEmail2} /> }
					{ Boolean(emailsCount>1 || email3) && <Autocomplete label="Email" name="emailRecipient3" getOptions={autocompleteEmail} onChange={setEmail3} /> }
					{ Boolean(emailsCount>2 || email4) && <Autocomplete label="Email" name="emailRecipient4" getOptions={autocompleteEmail} onChange={setEmail4} /> }
					{ Boolean(emailsCount>3 || email5) && <Autocomplete label="Email" name="emailRecipient5" getOptions={autocompleteEmail} onChange={setEmail5} /> }
					<Input label="Ragione sociale" name="offerRecipient" required />
					<Select label="Tipo di offerta" name="type" required options={offerTypes} onChange={setType} emptyLabel="--- seleziona una tipologia ---" />
				</Paper>
				<Paper sx={{ p:1, mb:1 }}>
					<InputNumber label="Filtra per altezza di lavoro" name="filterWorkingHeight" suffix="m" onChange={setWorkingHeight} />
					<Select label="Categoria prodotti" name="productCategory" required options={categoriesOpts} onChange={setCategory} emptyLabel="--- seleziona una categoria ---" />
					<Select label="Prodotto" name="product" required options={productsOpts} onChange={setProduct} emptyLabel="--- seleziona un prodotto ---" />
					{ type==='sale-used' && <Input label="Riferimento interno del prodotto" name="productReference" />}
				</Paper>
				
				<Paper sx={{ p:1, mb:1 }}>
					<InputNumber label="Prezzo" name="priceFull" suffix="€" required onChange={setPriceFull} />
					{ Boolean(data?.promotionLabel) && <Input label="Promozione" name="promotionLabel" disabled /> }
					<InputNumber label="Sconto" name="priceDiscount" suffix="%" required onChange={setPriceDiscount} disabled={Boolean(data?.promotionLabel)} />
					<InputNumber label="Prezzo finale" name="price" suffix="€" required disabled />
					{ Boolean(productData?.transportRequired) && (
						<>
							<Select label="Costi di trasporto" name="transportCosts" options={transportPrices} emptyLabel="Da definire" />
							{ Boolean(data?.shipDiscount) && <InputNumber label="Sconto trasporto" name="shipDiscount" suffix="%" disabled /> }
							<Input label="Destinazione trasporto" name="transportDestination" />
						</>
					)}
					<Input label="Note" name="notes" multiline />
				</Paper>
			</Form>
		</Tpl>
	)
}
